

<div class="container-fluid">
    <breadcrumb [showHome]="true"></breadcrumb>
</div>

<div class="container">

    <form class="form-horizontal">


        <!--<div class="form-group">
            <label>simple input</label>
            <input class="form-control" placeholder="yyyy-mm-dd" [(ngModel)]="model" name="date">
        </div>-->


        <div class="form-group">
            <label>Datepicker input</label>
            <div class="input-group">
                <input class="form-control" placeholder="yyyy-mm-dd"
                       name="dp" [(ngModel)]="model" ngbDatepicker #d="ngbDatepicker">
                <div class="input-group-btn">
                    <button class="btn btn-primary" (click)="d.toggle()">
                        <i class="far fa-calendar-alt"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="form-group">
            <button type="button" class="btn btn-secondary" placement="top" ngbTooltip="Tooltip on top">
                Tooltip on top
            </button>
        </div>

    </form>

    <div class="row">
        <hr />
        <pre>Selected date: {{ model | date: 'dd/MM/yyyy' }}</pre>
    </div>

</div>